import { environment } from "@tsin-env/environment";
import * as CryptoJS from 'crypto-js';


export function buildUrl(baseUrl: string, path: string, params?: { [key: string]: any }): string {
    let url = `${baseUrl}/${path}`;
    if (params) {
        const queryString = Object.keys(params)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&');
        url += `?${queryString}`;
    }
    return url;
}

export function encrypt(password: string): string {
    return CryptoJS.AES.encrypt(password, environment.salt).toString();
}